import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  languages,
  selectedLanguage,
} from '../../shared/components/header/elements/languages/languages.component';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/auth-api/user.service';
import { ResetPasswordRequest } from '../../services/auth-api/requests';
import { BaseResponseError } from '../../services/models/base.model';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  standalone: false,
})
export class ResetPasswordComponent {
  public form: FormGroup;
  public showPassword: boolean = false;
  public showConfirmPassword: boolean = false;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private translate: TranslateService,
    private toastrService: ToastrService,
    private userService: UserService
  ) {
    let lang =
      languages.find(
        (x) =>
          x.code.includes(navigator.language) ||
          navigator.language.includes(x.code)
      ) || selectedLanguage;
    this.translate.use(lang.code);

    let passwordPattern =
      '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
    this.form = this.fb.group({
      token: ['', [Validators.required]],
      email: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(255)],
      ],
      password: [
        '',
        [Validators.required, Validators.pattern(passwordPattern)],
      ],
      confirmPassword: [
        '',
        [Validators.required, Validators.pattern(passwordPattern)],
      ],
      rememberPhrase: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255),
        ],
      ],
    });
  }

  resetPassword() {
    if (this.form.valid) {
      this.loading = true;
      this.userService.resetPassword(
        new ResetPasswordRequest(
          this.form.controls.email.value,
          this.form.controls.token.value,
          this.form.controls.password.value,
          this.form.controls.rememberPhrase.value
        )
      )
      .subscribe({
        next: ({ data }) => {
          this.loading = false;
          this.toastrService.success(
            `<p>${data}</p>`,
            '',
            {
              closeButton: true,
              enableHtml: true,
              positionClass: 'toast-bottom-right',
            }
          );
          this.router.navigate(['/auth/login']);
        },
        error: (error) => {
          this.loading = false;
          console.error(error);
          if (error.error?.errors) {
            (error.error.errors as Array<BaseResponseError>)?.map(({ message }) => {
              this.toastrService.error(message, '', {
                closeButton: true,
                enableHtml: true,
                positionClass: 'toast-bottom-right',
              });
            });
          }
        },
      });
    }
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
